import { render, staticRenderFns } from "./PmAlarmManagementForP.vue?vue&type=template&id=aefec03a&"
import script from "./PmAlarmManagementForP.vue?vue&type=script&lang=js&"
export * from "./PmAlarmManagementForP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports